const HIDE_TOP_RATIO = 0.5;
const SHOW_BOTTOM_RATIO = 0.5;

export default class CapitalCampaignCta {
	static init() {
		const cta = document.querySelector('.capital-campaign-cta');
		if (!cta) {
			return;
		}

		const triggers = [...document.querySelectorAll('.capital-campaign-cta-hide-trigger')];
		if (!triggers.length) {
			return;
		}

		let ticking = false;

		const update = () => {
			ticking = false;
			const vh = window.innerHeight;
			const hideAt = vh * HIDE_TOP_RATIO;
			const showAt = vh * SHOW_BOTTOM_RATIO;

			const shouldHide = triggers.some((el) => {
				const rect = el.getBoundingClientRect();
				return rect.top <= hideAt && rect.bottom > showAt;
			});

			cta.classList.toggle('is-hidden', shouldHide);
		};

		const request = () => {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(update);
		};

		update();
		window.addEventListener('scroll', request, { passive: true });
		window.addEventListener('resize', request);
	}
}
